import React, { useRef, useState, useEffect } from "react";
import emailjs from "@emailjs/browser";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import PageLines from "../components/PageLines";
import MalaysiaMap from "../components/MalaysiaMap";
import ContactSection from "../components/ContactSection";
import CustomLoader from "../components/CustomLoader";

function Contacts() {
  const form = useRef();
  const [status, setStatus] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    // Hide loader after 2 seconds
    const timer = setTimeout(() => {
      setIsLoading(false);
    }, 2000);

    return () => clearTimeout(timer);
  }, []);

  const sendEmail = (e) => {
    e.preventDefault();
    emailjs
      .sendForm(
        "service_f1sh5pd",
        "template_637awhg",
        form.current,
        "6wSJlxr2YtGvthAtJ"
      )
      .then(() => {
        setStatus("success");
        form.current.reset();
      })
      .catch((error) => {
        console.error("Email send failed:", error);
        setStatus("error");
      });
  };

  return (
    <div className="layout">
      {/* Custom Loader */}
      {isLoading && <CustomLoader />}
      <Navbar />
      <main
        className="main main-inner main-contacts bg-contacts"
        data-stellar-background-ratio="0.6"
      >
        <div className="container">
          <header className="main-header">
            <h1>Contacts</h1>
          </header>
        </div>
        <PageLines />
      </main>

      <div className="content">
        {/* Contact & Map Section */}
        <section className="responsive-contact">
          {/* Google Map on LEFT */}
          <div className="map-wrapper">
            <div className="gmap">
              <iframe
                title="Xinchuan Location"
                src="https://www.google.com/maps?q=5375,+Jalan+Kenari+20,+Bandar+Putra+Kulai,+Johor,+Malaysia&output=embed"
                style={{
                  width: "100%",
                  height: "100%",
                  border: 0,
                }}
                allowFullScreen=""
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
              ></iframe>
            </div>
          </div>

          {/* Contact Info on RIGHT */}
          <div className="contact-info-wrapper">
            <div className="contact-info-content">
              <div className="contact-info-title">Contacts</div>

              <div className="contact-row phone">
                <i className="fa fa-phone"></i>
                <div className="contact-body">
                  <h4>Phone</h4>
                  <div className="phone-row">+60(19) 578-0801</div>
                  <div className="phone-row">+60(7) 597-0720</div>
                </div>
              </div>

              <div className="contact-row">
                <i className="fa fa-envelope"></i>
                <div className="contact-body">
                  <h4>Email</h4>
                  <div className="contact-content">sales@xinchuan.site</div>
                </div>
              </div>

              <div className="contact-row">
                <i className="fa fa-map-marker"></i>
                <div className="contact-body">
                  <h4>Address</h4>
                  <div className="contact-content">
                    No 987, Jalan Idaman 2/15/5, Taman Desa Idaman,
                    <br />
                    81400 Senai, Johor Darul Ta'zim
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Malaysia Coverage Map */}
        <section id="objects" className="objects section">
          <div className="container">
            <header className="section-header">
              <h2 className="section-title">
                We are <span className="text-primary">all over Malaysia</span>
              </h2>
            </header>
            <div className="section-content">
              <MalaysiaMap />
            </div>
          </div>
        </section>

        <ContactSection />
        <Footer />
        <PageLines />
      </div>

      {/* 👇 Inline Styling (or move to your CSS file) */}
      <style>{`
        .responsive-contact {
          display: flex;
          flex-wrap: wrap;
        }

        .contact-info-wrapper {
          background-color: #c9a57d;
          flex: 1 1 100%;
          padding: 2rem;
          box-sizing: border-box;
          z-index: 2;
          position: relative;
        }

        .map-wrapper {
          flex: 1 1 100%;
          height: 350px;
          margin-top: -120px;
          z-index: 1;
          position: relative;
        }

        .gmap {
          width: 100%;
          height: 100%;
        }

        @media (min-width: 991px) {
          .responsive-contact {
            flex-wrap: nowrap;
          }

          /* Map on the LEFT */
          .map-wrapper {
            flex: 0 0 60%;
            margin-top: 0;
            height: auto;
          }

          /* Contact on the RIGHT */
          .contact-info-wrapper {
            flex: 0 0 40%;
            padding: 2rem;
            z-index: 2;
          }
        }
      `}</style>
    </div>
  );
}

export default Contacts;
